'use strict';

(function ($) {

	/**
  * Accordion
  *
  * @author Matthias Giger <matthias.giger@namics.com>
  */
	T.Module.Accordion = T.createModule({

		// When decorator accordion-footer is used these will be overwritten.
		_selectors: {
			panel: '[data-js-o-accordion__panel]',
			title: '[data-js-o-accordion-title]',
			toggle: '[data-js-o-accordion__toggle]',
			table: 'table'
		},

		_stateClasses: {
			open: 'state-open',
			closed: 'state-closed'
		},

		_eventNames: {
			responsiveTable: 'pageController.responsiveTables'
		},

		start: function start(resolve) {
			this.$ctx = $(this._ctx);

			// References
			this.$panels = this.$ctx.find(this._selectors.panel);
			this.$titles = this.$ctx.find(this._selectors.toggle);

			this.$titles.click(this.handleClick.bind(this));

			this.initializeAccordion();

			resolve();
		},
		initializeAccordion: function initializeAccordion() {
			var _this = this;

			this.$panels.each(function (index, element) {
				var $panel = $(element);
				// By default panels are closed
				if (!$panel.hasClass(_this._stateClasses.open) && !$panel.hasClass(_this._stateClasses.closed)) {
					$panel.addClass(_this._stateClasses.closed);
				}
			});

			this.$titles.each(function (index, element) {
				if (!$(element).hasClass(_this._stateClasses.open) && !$(element).hasClass(_this._stateClasses.closed)) {
					$(element).addClass(_this._stateClasses.closed);
				}
			});

			// we need to preload the images within the accordion to have them available for print
			this.$ctx.find('.a-image__img.lazyload').addClass('lazypreload');
		},
		handleClick: function handleClick(event) {
			var $link = this.findPanel(event);
			var $parent = $link.parent();
			var $content = $parent.next();

			// Re-assign $parent and $content if attribute toggle set
			if ($link.hasAttr(this._selectors.toggle)) {
				$parent = $link;
				$content = $parent.next();
			}

			if (this.initiallyOpen) {
				this.$panels.slideUp();
			} else {
				$content.slideUp();
			}

			if (!$content.is(':visible')) {
				this.openAccordion($content, $parent);
			} else {
				this.closeAccordion($content, $parent);
			}

			return false;
		},
		findPanel: function findPanel(event) {
			var $link = $(event.target);

			// Re-assign $link if attribute toggle set
			while (!$link.hasAttr(this._selectors.toggle)) {
				$link = $link.parent();
				// Break: Only interessted in 1st element.
				break;
			}

			return $link;
		},
		openAccordion: function openAccordion($content, $parent) {
			$content.slideDown(400, this.onAccordionPanelOpen.bind(this));
			$parent.addClass(this._stateClasses.open);
			$content.addClass(this._stateClasses.open);
			$parent.removeClass(this._stateClasses.closed);
			$content.removeClass(this._stateClasses.closed);
		},
		closeAccordion: function closeAccordion($content, $parent) {
			$parent.addClass(this._stateClasses.closed);
			$content.addClass(this._stateClasses.closed);
			$parent.removeClass(this._stateClasses.open);
			$content.removeClass(this._stateClasses.open);
		},


		/**
   * Check if we have a table within the accordion and emit event to initialize the responsive behaviour
   *
   * @returns {undefined}
   */
		onAccordionPanelOpen: function onAccordionPanelOpen() {
			var $tables = $(this._selectors.table, this.$ctx);

			if ($tables.length > 0) {
				this._events.emit(this._eventNames.responsiveTable, $tables);
			}
		}
	});
})(jQuery);